import { render, staticRenderFns } from "./ShowSalesByTerritory.vue?vue&type=template&id=54d782cb&"
import script from "./ShowSalesByTerritory.vue?vue&type=script&lang=js&"
export * from "./ShowSalesByTerritory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports